import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/components/base.component';

@Component({
    selector: 'features-component',
    standalone: true,
    imports: [...BaseComponent.BaseImports],
    templateUrl: './FeaturesComponent.html',
    styleUrl: './FeaturesComponent.css',
})

export class FeaturesComponent implements BaseComponent, OnInit
{
    constructor()
    {
    }

    async ngOnInit()
    {
    }
}
